var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43286 16.0558C0.163635 14.7866 0.163635 12.7289 1.43286 11.4597L11.5445 1.34803C12.8137 0.0788025 14.8715 0.0788021 16.1407 1.34803C17.4099 2.61726 17.4099 4.675 16.1407 5.94422L8.32715 13.7578L16.1407 21.5713C17.4099 22.8405 17.4099 24.8982 16.1407 26.1675C14.8715 27.4367 12.8137 27.4367 11.5445 26.1675L1.43286 16.0558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.21db0f25cdd864e29871752b82928e54.svg";
export { ForwardRef as ReactComponent };